// extracted by mini-css-extract-plugin
export default {"menuBlock":"yE-z","title":"zE-z","nav":"AE-z","flexCell":"BE-z","facetLink":"CE-z"};